export const PASSWORD_MIN_LENGTH = 8;

/** Aligned with movil-security PasswordPolicy.kt */
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;

export type PasswordPolicyChecks = {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasSpecialChar: boolean;
};

export const getPasswordPolicyChecks = (
  password: string,
): PasswordPolicyChecks => ({
  hasMinLength: password.length >= PASSWORD_MIN_LENGTH,
  hasUppercase: /[A-Z]/.test(password),
  hasLowercase: /[a-z]/.test(password),
  hasSpecialChar: /[^A-Za-z0-9]/.test(password),
});

export const isPasswordPolicyValid = (password: string): boolean =>
  PASSWORD_POLICY_REGEX.test(password);

export const isPasswordPolicyChecksValid = (
  checks: PasswordPolicyChecks,
): boolean =>
  checks.hasMinLength &&
  checks.hasUppercase &&
  checks.hasLowercase &&
  checks.hasSpecialChar;
